import { common } from '@mui/material/colors';
import { alpha, PaletteOptions } from '@mui/material/styles';

const neutral = {
  100: '#F3F4F6',
  200: '#E5E7EB',
  300: '#D2D6DB',
  400: '#9DA4AE',
  50: '#F8F9FA',
  500: '#6C737F',
  600: '#4D5761',
  700: '#2F3746',
  800: '#1C2536',
  900: '#111927',
};

const grey = {
  300: '#E0E0E0',
};

const primary = {
  contrastText: '#FFFFFF',
  dark: '#109962',
  darkest: '#076753',
  darkestBg: '#022723',
  light: '#6EE792',
  lightest: '#CFFBD3',
  main: '#17B264',
  selected: 'rgba(23, 178, 100, 0.12)',
};

const secondary = {
  contrastText: '#FFFFFF',
  dark: '#2F3746',
  darkMedium: '#15202E',
  darkest: '#111927',
  light: '#EAEFF5',
  lightest: '#F8FAFC',
  main: '#6C737F',
};

const error = {
  contrastText: '#FFFFFF',
  dark: '#B42318',
  darkest: '#7A271A',
  light: '#FEE4E2',
  lightest: '#FEF3F2',
  main: '#F04438',
};

const warning = {
  contrastText: '#FFFFFF',
  dark: '#B54708',
  darkest: '#7A2E0E',
  light: '#FEF0C7',
  lightest: '#FFFAEB',
  main: '#F79009',
};

const info = {
  contrastText: '#FFFFFF',
  dark: '#0E7090',
  darkest: '#164C63',
  light: '#CFF9FE',
  lightest: '#ECFDFF',
  main: '#06AED4',
};

const success = {
  contrastText: '#FFFFFF',
  dark: '#107569',
  darkest: '#134E48',
  light: '#CCFBEF',
  lightest: '#F0FDF9',
  main: '#15B79E',
};

export const darkThemePalette = {
  action: {
    active: neutral[500],
    disabled: alpha(neutral[100], 0.38),
    disabledBackground: alpha(neutral[100], 0.12),
    focus: alpha(neutral[100], 0.16),
    hover: alpha(neutral[100], 0.04),
    selected: alpha(neutral[100], 0.12),
  },
  alert: {
    error: {
      background: error.light,
      content: error.darkest as string,
    },
    info: {
      background: info.light,
      content: info.darkest as string,
    },
    success: {
      background: success.main,
      content: secondary.darkest,
    },
    warning: {
      background: '#FDEAD7',
      content: '#772917',
    },
  },
  background: {
    default: '#0E1320',
    paper: neutral[900],
    paperGlass: alpha(neutral[900], 0.9),
    paperTertiary: neutral[800],
    table: 'rgba(107, 151, 227, 0.05)',
  },
  common,
  divider: '#29303D',
  error,
  grey,
  info,
  mode: 'dark' as PaletteOptions['mode'],
  nav: {
    discreet: '#F3F4F6',
    evident: '#B5BCC4',
    evidentActive: '#EDF2F7',
    evidentBg: '#1C2536',
    evidentDivider: '#2F3746',
  },
  neutral,
  primary: {
    ...primary,
    hovered: alpha('#16b364', 0.08),
  },
  secondary: {
    ...secondary,
    hovered: alpha('#6C737F', 0.08),
  },
  success,
  text: {
    disabled: alpha('#FFFFFF', 0.48),
    primary: '#EDF2F7',
    secondary: '#C8CBD0',
  },
  warning,
};
